import styled from 'styled-components';

const StyledIconButton = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors.textColor; }};
  background-color: ${props => { var _a; return (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : 'transparent'; }};
  border: none;
  cursor: pointer;
  transition: background-color 0.1s, color 0.1s;
  padding: 0;
  outline: none;

  @media (pointer: fine) {
    &:hover {
      color: ${props => { var _a; return (_a = props.hoverColor) !== null && _a !== void 0 ? _a : props.theme.colors.textColor; }};
      background-color: ${props => { var _a; return (_a = props.hoverBackground) !== null && _a !== void 0 ? _a : 'transparent'; }};
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
const IconContainer = styled.span `
  svg {
    transform: ${props => { var _a; return props.size ? (_a = props.theme.interactive.iconButton[props.size]) === null || _a === void 0 ? void 0 : _a.transform : 'none'; }};
  }
`;

export { IconContainer, StyledIconButton };
//# sourceMappingURL=IconButton.styles.mjs.map
